export const contentData = {
  spanish:{
    layout:{
      title:'Agregar Aseguradora Pública',
      navigation:[
        {name:'Catálogos',path:'/catalogs'},
        {name:'Aseguradoras Públicas',path:'/catalogs/public_insurances'},
        {name:'Agregar',path:'/catalogs/public_insurances/add'}
      ],
      menu:null
    },
    header:['ID','Nombre','Email','Teléfono','Género']
  }
}